import { TActivity } from "./activity";
import { TCoupon } from "./coupon";
import { TEvent } from "./event";
import { TUser } from "./user";

export enum EBookingStatus {
  DRAFT = "draft",
  PAYMENT_PENDING = "payment-pending",
  CONFIRMED = "confirmed",
  PAYMENT_CANCELLED = "payment-cancelled",
  CANCELLED = "cancelled",
  SCAM = "scam",
  EXPIRED = "expired",
}

export type TBooking = {
  id: string | null;
  password: string | null;
  event: TEvent | null;
  people: number;
  activity: TActivity | null;
  coupon: TCoupon | null;
  status: EBookingStatus;
  user: TUser | null;
  otherUsers: TUser[];
  createdAt: Date;
  createdDate?: Date;
  isEditable: boolean;
  needsEnglish: boolean;
  paymentId: string | null;
  cancelledInWebhook?: boolean;
  confirmedInWebhook?: boolean;
  paidFully?: boolean;
  payHalf?: boolean;
  payment2Id?: string | null;
  userPackId?: string;
  notes?: string;
};

export type TBookingStore = {
  booking: TBooking;
  setBooking: (booking: TBooking) => void;
  resetBooking: () => void;
};
